module.exports = __webpack_public_path__ + "static/img/WechatIMG198.b137c06.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/WechatIMG198.png
// module id = B+lu
// module chunks = 1